export default __webpack_public_path__ + "static/media/fcf-and-profitability-2.a39421e3.png";